import { createFileRoute, Link, redirect, useNavigate } from "@tanstack/react-router";
import { RouterContext } from "../types/routerContext.ts";
import { getAuthorizationService } from "../utils/auth.ts";
import { EmptyState } from "@floriday/floriday-ui";
import { Box, Button } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useOktaAuth } from "@okta/okta-react";

export const Route = createFileRoute("/no-permission")({
  component: RouteComponent,
  beforeLoad: async ({ context }: { context: RouterContext }) => {
    const { accessToken } =
      await context.auth.oktaAuth.tokenManager.getTokens();
    if (accessToken && getAuthorizationService().hasRequiredScopeSync(accessToken)) {
      throw redirect({
        to: "/",
      });
    }
  },
});

function RouteComponent() {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const { authState, oktaAuth } = useOktaAuth();
  const scopes = authState?.accessToken?.scopes || [];

  return (
    <Box sx={{ mt: 8, justifyItems: "center" }}>
      <EmptyState
        graphic="/assets/empty-state.svg"
        header={t("common.noPermission.header")}
        subheader={
          authState?.isAuthenticated ? (
          <Trans
            i18nKey={"common.noPermission.subHeader"}
            values={{ scopes: scopes.join(", ") }}
          >
            De authenticatie scopes{" "}
            <code style={{ marginLeft: 5, marginRight: 5, fontSize: "1rem" }}>
              scope
            </code>{" "}
            komen niet overeen met deze applicatie.
          </Trans>
          ) : t('common.noPermission.notAuthenticated')
        }
        bottomComponent={
          <Button
            variant="contained"
            color={"primary"}
            component={Link}
            onClick={async () => {
              if (authState?.isAuthenticated) {
                await oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin });
              } else {
                navigate({ to: "/" });
              }
            }}
            to={"/"}
          >
            {authState?.isAuthenticated ? t("common.noPermission.loginAgain") : t("common.noPermission.login")}
          </Button>
        }
      />
    </Box>
  );
}
